
import { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../Assets/Css/home.css';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import aboutimg from '../Assets/Image/xtragrowfoundation_aboutus.jpeg'
import { Helmet } from 'react-helmet';
import slide1 from '../Assets/Image/slider001.jpg.jpeg'
import slide2 from '../Assets/Image/slider02.jpg.jpeg'
import slide3 from '../Assets/Image/slider03.jpg.jpeg'
import Education from '../Assets/Image/education.jpeg'
import Community from '../Assets/Image/community.jpeg'
import Health from '../Assets/Image/health.jpeg'
import Innovation from '../Assets/Image/innovation.jpeg'

import img1 from '../Assets/Image/gallery1.jpeg'
import img2 from '../Assets/Image/gallery2.jpeg'
import img3 from '../Assets/Image/gallery3.jpeg'
import img4 from '../Assets/Image/gallery4.jpeg'
import img5 from '../Assets/Image/gallery5.jpeg'
import img6 from '../Assets/Image/gallery6.jpeg'

import ctaimg from '../Assets/Image/ctaimages.avif'

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { FaStar } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import leftagrow from '../Assets/Image/plant1.png'
import rightagrow from '../Assets/Image/plant2.png'

import plantcrop from '../Assets/Image/sustainable_farming3.avif'
import { RiArrowRightDoubleFill } from "react-icons/ri";

import { useNavigate } from 'react-router-dom';



const slides = [
  {
    image: slide1,
    title: 'XtraGrow Foundation, Inc.',
    description: 'XtraGrow Foundation educates kids from 4th grade to college on the benefits of organic farming.',
  },
  {
    image: slide2,
    title: 'XtraGrow Foundation, Inc.',
    description: 'XtraGrow Foundation educates children from 4th grade through college on the benefits of premium organic agriculture.',
  },
  {
    image: slide3,
    title: 'XtraGrow Foundation, Inc.',
    description: 'XtraGrow Foundation teaches kids from 4th grade to college about the benefits of premium organic farming.',
  },
];

const testimonials = [
  {
    text: "XtraGrow empowers young minds through sustainable and organic farming practices.",
    role: "— Community Leader"
  },
  {
    text: "Our students now value the importance of growing healthy local food.",
    role: "— Local Educator"
  },
  {
    text: "They turned simple awareness into real action and lasting community change.",
    role: "— NGO Partner"
  },
  {
    text: "This initiative brought knowledge, hope, and purpose to our children’s lives.",
    role: "— Parent Advocate"
  },
  {
    text: "XtraGrow plants seeds of leadership, health, and environmental responsibility daily.",
    role: "— Social Worker"
  }
];



export default function HomePage() {

const navigate = useNavigate();
  const servicesData = [
    {
      title: "Education",
      img: Education,
      dec: 'Empowering youth through knowledge and practical skills in sustainable agriculture.'
    },
    {
      title: "Community",
      img: Community,
      dec: 'Fostering partnershipsand collaboration to support local farming initiatives.'

    },
    {
      title: "Health",
      img: Health,
      dec: 'Promoting nutritionand well-being through organic farming practices. '

    },
    {
      title: "Innovation",
      img: Innovation,
      dec: 'Encouraging creativity and forward-thinking solutions inagriculture.'
    },


  ];

  const galleryImages = [img1, img2, img3, img4, img5, img6];




  const [activeIndex, setActiveIndex] = useState(0);
  const [aosKey, setAosKey] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 1000 });
    setTimeout(() => {
      AOS.refresh();
      setAosKey(k => k + 1);
    }, 100);
  }, []);

  return (
    <>
      <div className="mainnav min-vh-100">
<Helmet>
        <title>XtraGrow Foundation | Empowering Sustainable Agriculture</title>
        <meta name="description" content="XtraGrow Foundation educates children from 4th grade through college about premium organic farming. Join us in building a healthier future." />
        <meta name="keywords" content="organic farming, sustainable agriculture, youth education, community health, farming education, XtraGrow Foundation" />
        <meta name="author" content="XtraGrow Foundation" />
        <link rel="canonical" href="https://xtragrowfoundation.org/" />
        <meta property="og:title" content="XtraGrow Foundation | Empowering Sustainable Agriculture" />
        <meta property="og:description" content="Empowering youth and communities through education in organic and sustainable farming practices." />
        <meta property="og:url" content="https://xtragrowfoundation.org/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://xtragrowfoundation.org/images/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>


        <section className="hero-slider">
          <Swiper
            modules={[Autoplay, Pagination]}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            loop={true}
            onSlideChange={(swiper) => {
              setActiveIndex(swiper.realIndex);
              AOS.refresh();
            }}
          >
            {slides.map((slide, index) => (
              <SwiperSlide key={index}>

                <div className="slide-content">
                  <div
                    className="slide-bg"
                    style={{ backgroundImage: `url(${slide.image})` }}
                  ></div>
                  <div className="overlay-content" key={`${activeIndex}-${aosKey}`}>
                    <h1 data-aos="fade-up" data-aos-delay="100">{slide.title}</h1>
                    <p data-aos="zoom-in" data-aos-delay="300">{slide.description}</p>
                    <a  className="btn-donate" data-aos="zoom-in" data-aos-delay="500"
                      onClick={() => navigate("/donationpayment")}
                    >
                    Donate Now</a>
                  </div>
                </div>

              </SwiperSlide>
            ))}
          </Swiper>
        </section>


        {/* About Section Preview */}
        {/* About Section */}
        <section className="about-preview py-5">
          <Container>
            <Row className="align-items-center">
              {/* Text Section */}
              <Col md={6}>
                <h2 className='page-title' data-aos="fade-up" > About <span style={{ color: '#078825' }}> Us</span> </h2>
                <div style={{ textAlign: 'justify' }} data-aos="zoom-in" data-aos-delay="200">
                  <p className='homeabouttext'>
                    Welcome to
                    <span style={{ color: '#036839', fontWeight: 'bold' }}> XTRAGROW</span>
                    <span style={{ color: '#3CB649', fontWeight: 'bold' }}> Foundation, Inc., </span>
                    a recognized 501(c)3 public charity dedicated to fostering sustainable agriculture and community health through education and empowerment.
                  </p>

                </div>
                <a href="/aboutus" className="btn-learn mb-4" data-aos="zoom-in"> Learn More <RiArrowRightDoubleFill /> </a>
              </Col>

              {/* Image Section */}
              <Col md={6}>
                <div className="d-flex justify-content-center">
                  <img
                    src={aboutimg}
                    alt="Xtragrow About"
                    className="img-fluid aboutimg rounded shadow"
                    data-aos="zoom-in"
                    data-aos-delay="200"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="services-summary py-5 mb-4">
          <Container>
            <h2 className='page-title' data-aos="fade-up">Core   <span style={{ color: '#078825' }}> Values</span>  </h2>
            <p data-aos="zoom-in" data-aos-delay="100">
              XtraGrow Foundation, Inc. collaborates with organizations that share our commitment to sustainable agriculture and community health.
            </p>
            <Row className="gx-3 mt-4">
              {servicesData.map((service, index) => (
                <Col key={index} lg={3} md={4} sm={6} xs={12} className="mb-3" data-aos="flip-up"
                  data-aos-delay={index * 100 + 200}>
                  <Card className="h-100 servicecard">
                    <Card.Img
                      variant="top"
                      src={service.img}
                      style={{ height: '150px', objectFit: 'cover' }}
                    />
                    <Card.Body className="text-center">
                      <h4 className='servicetext'>{service.title}</h4>
                      <h6 style={{ lineHeight: '1.5' }}>{service.dec}</h6>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>



        <section className='py-4'>
  <Container>
    <Row className='align-items-center'>
      <Col lg={12} className='ruraleduleft order-2 order-lg-1 text-center'>
        <h2 className='page-title' data-aos="fade-up" > Empowering Communities through <br /> <span style={{ color: '#078825' }}> Sustainable Agriculture </span> </h2>
         <p className='fs-5' data-aos="zoom-in">
          Enabling Local Farmers and Youth with Training, Tools, and Support
        </p>
        <img src={plantcrop} alt="plantcrop" className='ruraleducation mt-3'
        data-aos="zoom-in" data-aos-delay="200"
         />
      </Col>
    </Row>
  </Container>
</section>


        <Container className="py-5">
          <Row className="justify-content-center">
            <Col md={10}>
              <div className="who-we-are-section p-5 rounded ">
                <h2 className='page-title' data-aos="fade-up">Our  <span style={{ color: '#078825' }}> Partners</span>  </h2>
                <p className="text-center  text-dark" data-aos="zoom-in">
                  XtraGrow Foundation, Inc. collaborates with organizations that share our commitment to sustainable agriculture and community health. We welcome partnerships with like-minded entities to amplify our impact and reach more individuals dedicated to promoting Premium Organic farming practices.
                </p>
                <p data-aos="zoom-in">
                  For more information about our initiatives, programs, or partnership opportunities, please contact us.
                </p>
                
              </div>
            </Col>
          </Row>
        </Container>

        <section className="impact-section py-5" style={{ backgroundColor: '#f7fdf9' }}>
          <Container>
            <h2 className='page-title text-center mb-3' data-aos="fade-up">
           Together We <span style={{ color: '#3CB649' }}>Grow</span> Stronger
            </h2>

            <Row className="" data-aos="fade-up" data-aos-delay="200">
              <Col md={6} className="mb-4">
                <img
                  src={ctaimg}
                  alt="Children Farming"
                  className="ctahomeimg img-fluid rounded shadow"
                />
              </Col>
              <Col md={6}>
                <div className='mb-5'>
                  <h2 className='ctatitle' data-aos="fade-up" data-aos-delay="100">
                    Support the future of sustainable farming. <br />
                  </h2>
                  <p data-aos="fade-up" data-aos-delay="100" style={{ fontSize: '16px' }}>
                    Your donation enables us to educate young minds and cultivate greener communities through hands-on learning.
                  </p>
                </div>
                <Button
                  variant="success"
                  size="lg"
                  className="px-4 py-2 btn-donate"
                 onClick={() => navigate("/donationpayment")}
                  data-aos="zoom-in" data-aos-delay="100"
                >
                  Donate Now
                </Button>
              </Col>
            </Row>
          </Container>
        </section>



        <section className="services-summary py-5 ">
          <Container>
            <h2 className='page-title' data-aos="fade-up">Our <span style={{ color: '#078825' }}> Gallery</span>  </h2>

            <Row>
              {galleryImages.map((imgSrc, index) => (
                <Col md={4} sm={6} xs={12} key={index} className="mb-4" data-aos="zoom-in">
                  <Card className="gallery-card shadow-sm">
                    <Card.Img variant="top" src={imgSrc} className="gallery-image" />
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className="py-5 testimonial-carousel-section mb-1">
          <div className="container  ">
            <Row className="align-items-end flex-column flex-md-row m-0">
              <Col xs={12} md={2} className="d-flex justify-content-center justify-content-md-start order-2 order-md-1 chocolates-col">
                <img
                  src={leftagrow}
                  alt="crop Left"
                  className="chocolate-image"
                  data-aos="zoom-in" data-aos-delay="200"
                />
              </Col>

              <Col xs={12} md={8} className="text-center order-1 order-md-2" data-aos="zoom-in" data-aos-delay="200">
                <h2 className="page-title text-center mb-4" data-aos="fade-up">
                  Stories <span style={{ color: '#078825' }}>That Inspire</span>
                </h2>
                <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
                  Inspiring stories from those impacted by our organic farming and education efforts.
                </p>


                <Swiper
                  modules={[Pagination, Autoplay]}
                  spaceBetween={30}
                  slidesPerView={1}
                  pagination={{ clickable: true }}
                  autoplay={{ delay: 3500 }}
                  loop={true}
                >
                  {testimonials.map((item, idx) => (
                    <SwiperSlide key={idx}>
                      <div className="testimonial-slide  text-center  p-3 ">
                        <div className="stars mb-2 ">
                          {[...Array(5)].map((_, i) => (
                            <FaStar key={i} />
                          ))}
                        </div>
                        <p className="testimonial-quote">
                          <span className="quote-mark">“</span>
                          {item.text}
                          <span className="quote-mark">”</span>
                        </p>
                        <p className="author-name">{item.role}</p>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>

              </Col>

              <Col xs={12} md={2} className="d-flex justify-content-center justify-content-md-end order-0 order-md-3 chocolates-col">
                <img
                  src={rightagrow}
                  alt="crop Right"
                  className="chocolateright-image"
                  data-aos="zoom-in" data-aos-delay="200"
                />
              </Col>
            </Row>
          </div>
        </section>
      </div>
    </>
  );
}
